import { Component } from '@angular/core';
import { AppService } from '@irb/app.service';
import { INoRowsOverlayAngularComp } from 'ag-grid-angular';
import { IrbSettingsEvents } from '@irb/irb-common/events';

@Component({ standalone: false,
  selector: 'irb-dialog-portfolio-custom-labels-norow',
  templateUrl: './dialog-portfolio-custom-labels-modify.no-rows.html'
})
export class DialogPortfolioCustomLabelsModifyNoRowComponent implements INoRowsOverlayAngularComp {

  params: any;

  constructor(private as: AppService) { }

  agInit(params: any): void {
    this.params = params;
  }

  openGlobalSettings() {
    this.as.fireEvent(IrbSettingsEvents.SHOW, {
      defaultTabIndex: 2, 
      onFirstLoad: () => { 
        setTimeout(() => { 
          this.as.fireEvent(IrbSettingsEvents.EXPAND_CUSTOM_LABELS);
          document.getElementById("CUSTOM_CATEGORIES")?.scrollIntoView(); 
        });
      }
    });
    
    if(this.params.onOpenGlobalSettings) {
        this.params.onOpenGlobalSettings();
    }
  }
}
